import circleAnimation from './circle.json'
import _ from 'lodash'

export const replaceAnimationCircleColor = (circleJson, [r, g, b]) => {
  const copy = _.cloneDeep(circleJson)
  const output = _.set(copy, [
    'layers', '0', 'shapes', '0', 'it', '1', 'c', 'k'
  ], [
    r/255, g/255, b/255, 1
  ])
  return output
}

export const campaignIgnoreSites = ['VV', 'IHH', 'CF']
export const campaignMenuVisibleSites = ['FEW']
/** Donors must not pick billing day-of-month (charge from signup / existing schedule only). */
export const sitesHidePaymentDateMenu = ['VV']

export const isPaymentDateMenuVisible = ({ site, layoutConfig, guestMode }) => (
  !sitesHidePaymentDateMenu.includes(site)
  && layoutConfig?.paymentDateMenu?.visible !== false
  && !guestMode
)

export const merchantNames = {
  'STS': 'Save the Storks',
  'VV': 'Mama Bear Care',
  'FEW': 'For Every Woman',
  'IHH': 'In His Hands',
  'CF': 'Caring Families',
}

export const siteLinkUrl = {
  STS: 'https://savethestorks.org',
  // VV: 'https://veritysvillage.com',
  VV: 'https://mamabearcare.org',
  FEW: 'https://foreverywoman.org',
  IHH: 'https://www.ihhministry.org',
  CF: 'https://www.carefamilies.org/',
}
export const sitePhone = {
  STS: '(866) 639-0479',
  VV: '(555) 123-4567',
}
export const siteGeneralBackgroundImage = {
  STS: utmCampaign => `/server/assets/images/${utmCampaign === '' || typeof utmCampaign === 'undefined' ? 'header-main.jpg' : ('campaigns/' + utmCampaign + '.png')}`,
  FEW: () => '/server/assets/images/header-main.png',
  // FEW: () => '/server/assets/images/hero-search-women-c.png',
  IHH: () => '/server/assets/images/header-main.webp',
  CF: () => '/server/assets/images/header-main.avif',
}
export const siteGeneralBackgroundImageStyle = {
  VV: {
    minHeight: 250,
    width: '100%', 
    position: 'relative',
    backgroundImage: 'url(/server/assets/images/header-main.jpeg)',
    backgroundPosition: '91% 50%',
    backgroundSize: 'cover',
  },
  FEW: {
    width: '100%',
    position: 'relative',
    // maxHeight: 400,
    maxWidth: 1200,
    marginLeft: 'auto',
    marginRight: 'auto',
    // background: 'linear-gradient(to right, rgb(199, 158, 152), rgb(236, 219, 199))',
  },
}
export const expressFlowMainImage = {
  STS: '/server/assets/images/express-main.png',
}
export const siteSuccessBackgroundImage = {
  STS: 'https://savethestorks.org/wp-content/uploads/2021/08/media_blue_swash_rev.png',
  // VV: 'https://veritysvillage.com/wp-content/uploads/2021/03/evan-kirby-101570-unsplash-1024x683.jpg',
  VV: 'https://mamabearcare.org/wp-content/uploads/2021/03/evan-kirby-101570-unsplash-1024x683.jpg',
  FEW: '/server/assets/images/ultrasound_hero.jpg',
}
export const sitesWithTrapezoid = ['STS']
export const sitesWithPhoneNav = ['STS']
export const siteLogoStyles = {
  STS: { maxWidth: 120 },
  VV: { maxWidth: 160 },
  FEW: { },
}

export const siteImpactReportDict = {
  STS: '/wp-content/uploads/2021/11/Save-the-Storks-Midyear-Impact-Report-2021.pdf',
  VV: '',
  FEW: '',
}
export const siteEcfaLogoUrl = {
  STS: 'https://donate.savethestorks.org/images/ECFA-Accredited-150x150.png',
  FEW: 'https://donate.savethestorks.org/images/ECFA-Accredited-150x150.png',
}

export const siteDisclaimerText = {
  STS: 'Thank you for your support of the mission and programs of Save the Storks. Please note that the board maintains discretion and control over the use of the funds. This discretion is exercised by the board as they approve project the ministry will solicit funds. If the ministry receives a gift for a project that is not approved by the board, the ministry has authority to go back to a donor requesting a redesignation toward a current project or to be used for general purposes.'
}
export const siteProcessingFeeText = {
  STS: 'Help Save the Storks receive 100% of your donation!',
  default: 'Help us receive 100% of your donation!',
}

export const siteDefaultErrMsg = {
  general: {
    // STS: 'We are in the process of transferring to a new credit card processor. If you encounter any issues with your donation please call 866-639-0479, ext. 1, M-F 8a-5p MST, or email the team at info@savethestorks.org.',
    STS: 'We have run into an error processing your donation.  If you continue to encounter an issue with your donation please call 866-639-0479, ext. 1, M-F 8am - 5pm MST, or email the team at info@savethestorks.org.',
    VV: 'We have run into an error processing your donation. If you continue to encounter an issue with your donation please email the team at VeritysVillage@gmail.com.',
    default: 'We have run into an error processing your donation.',
  },
  plaid: {
    STS: 'Bank Account Error: Please select Bank Account (ACH) and retry your bank account numbers or to complete your donation please call 866-639-0479, ext. 1, M-F 8a-5p MST, or email the team at info@savethestorks.org.',
    VV: 'Bank Account Error: Please select Bank Account (ACH) and retry your bank account numbers or to complete your donation please email the team at VeritysVillage@gmail.com.',
    default: 'Bank Account Error: Please select Bank Account (ACH) and retry your bank account numbers.',
  }
}

export const siteSuccessImage = {
  STS: '/server/assets/images/success.jpeg',
  VV: '/server/assets/images/success.png',
  FEW: '/server/assets/images/success.jpeg',
  EMA: '/server/assets/images/success.jpeg',
  IHH: '/server/assets/images/success.webp',
  CF: '/server/assets/images/success.avif',
}
export const siteSuccessImageStyle = {
  IHH: { maxWidth: 400 },
  CFF: { maxWidth: 400 },
}
export const siteThankYouText = {
  STS: 'Thank you for supporting Save the Storks!',
  VV: 'Thank you for supporting Mama Bear Care',
  FEW: 'Thank you for supporting For Every Woman and empowering women with options for real choice.',
  EMA: 'Thank you for supporting For Every Mother&#039;s Advocate.',
  IHH: 'Thank you for supporting In His Hands.',
  CF: 'Thank you for supporting Caring Families.'
}
export const siteSignUpButtonText = {
  FEW: 'Create an Account',
}
const circleAnimationVV = replaceAnimationCircleColor(circleAnimation, [235, 83, 127])
const circleAnimationFEW = replaceAnimationCircleColor(circleAnimation, [45, 48, 29])
const circleAnimationIHH = replaceAnimationCircleColor(circleAnimation, [187, 190, 170])
const circleAnimationCF = replaceAnimationCircleColor(circleAnimation, [34, 115, 115])

export const siteCircleAnimationDict = {
  STS: circleAnimation,
  EMA: circleAnimation,
  VV: circleAnimationVV,
  FEW: circleAnimationFEW,
  IHH: circleAnimationIHH,
  CF: circleAnimationCF,
}
export const siteThankYouTextStyle = {
  STS: { fontFamily: 'Montserrat', color: '#0d5e7d' },
  VV: { color: 'black' },
  FEW: { color: 'black' },
  EMA: { color: 'black' },
  IHH: { color: '#212529', fontFamily: 'Eyesome Script' },
  CF: { color: '#227373', marginTop: 10 },
}

export const siteDonateHeadlineText = {
  VV: "Donate Today: Join the Mama Bear Movement and Change a Family's Story",
  IHH: "Why Donate?",
}

export const siteOptionHighlightText = {
  VV: "You can adjust your giving at any time!",
}

export const siteOnlyShowTypes = {
  VV: ['yearly', 'monthly', 'one-time'],
}

export const donationTypeNames = {
  'yearly': 'Annually',
  'monthly': 'Monthly',
  'one-time': 'One-Time',
}
export const sitesWithDonateDescription = ['STS', 'FEW', 'IHH']

export const expressFlowDefaultCampaignId = {
  STS: '701Pd00000raCtwIAE',
}

/** When no CID in URL or cookie, use this campaign so the inspiration dropdown stays hidden (STS only). */
export const stsFallbackCampaignIdWhenMissingCid = '701Pd00001Bao2kIAB'

/**
 * Per-site fallback campaign id used when no CID is provided via URL/cookie and the
 * active layout doesn't specify `defaultCampaignId`. Add an entry here to give a site
 * its own default campaign.
 */
export const siteFallbackCampaignIdWhenMissingCid = {
  STS: stsFallbackCampaignIdWhenMissingCid,
}
